import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';

/** Userspezifische Menü-Einstellungen: ausgeblendete Menüpunkte (MenuKeys). */
export interface IMenuSettings {
  hidden: string[];
}

export const useMenuSettings = () => {
  const { data: menuSettings, isLoading: isLoadingMenuSettings } =
    useQuery<IMenuSettings>({
      queryKey: ['menuSettings'],
      queryFn: () => customFetcher({ endpoint: '/user/menusettings' }),
      staleTime: 5 * 60 * 1000,
    });
  return { menuSettings, isLoadingMenuSettings };
};

export const useUpdateMenuSettings = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateMenuSettings, isPending: isUpdatingMenuSettings } =
    useMutation({
      mutationFn: (hidden: string[]) =>
        customFetcher({
          endpoint: '/user/menusettings',
          method: 'PUT',
          body: { hidden },
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['menuSettings'] });
      },
    });
  return { updateMenuSettings, isUpdatingMenuSettings };
};
